<template>
  <div>
    <header class="w3-container" style="padding-top:22px">
      <h5>
        <i class="fas fa-globe"></i> Other Services
      </h5>
    </header>
  </div>
</template>

<script>
var dataStore = require("../dataStore").default

export default {
  name: "Services",
  data() {
    return {
      state: dataStore.state
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Services.vue